import request from "@/utils/request";
import { Message } from "element-ui";
import axios from "axios";
import { apiConfig } from "../utils/request";

// 用户登录
export function login(params) {
  return request({
    url: "/api/v1/login",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": false
    }
  });
}

//用户获取验证码
export function getCode(params) {
  console.log(params);
  return request({
    url: "/api/v1/email?email=" + params.email + "&type=" + params.type,
    method: "post",
    // data:params,
    headers: {
      "Content-Type": "application/json",
      "need-token": false
    }
  });
}

// 注册用户
export function registerEmail(params) {
  return request({
    url: "/api/v1/registerEmail",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": false
    }
  });
}

// 修改密码
export function forgetPass(params) {
  return request({
    url: "/api/v1/forgetPass",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": false
    }
  });
}

// 修改密码
export function passwordChange(params) {
  return request({
    url: "/api/v1/user/changePassword",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 查询用户列表
export function getUserList(params) {
  return request({
    url: "/api/v1/user/page",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 管理员添加用户
export function addUser(params) {
  return request({
    url: "/api/v1/user/add",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 删除用户
export function deleteUser(params) {
  return request({
    url: "/api/v1/user/delete/" + params,
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

// 删除用户
export function resetPassword(params) {
  return request({
    url: "/api/v1/user/resetPassword/" + params,
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

//修改用户信息
export function updataUser(params) {
  return request({
    url: "/api/v1/user/update",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//角色查询
export function getRoleList(params) {
  return request({
    url: "/api/v1/role/page",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//角色新增
export function addRole(params) {
  return request({
    url: "/api/v1/role",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//修改角色
export function updataRole(params) {
  return request({
    url: "/api/v1/role",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//角色删除
export function deleteRole(params) {
  return request({
    url: "/api/v1/role",
    method: "DELETE",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 获取菜单
export function getMenuList() {
  return request({
    url: "/api/v1/menu/select",
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

// 更新角色菜单
export function bindRoleMenu(params) {
  return request({
    url: "/api/v1/role/bind-menu",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品线查询
export function getListCategory(params) {
  return request({
    url: "/api/v1/product/category/page",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品线增加
export function addProductCategory(params) {
  return request({
    url: "/api/v1/product/category",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品线修改
export function updataProductCategory(params) {
  return request({
    url: "/api/v1/product/category",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品线删除
export function deleteProductCategory(params) {
  return request({
    url: "/api/v1/product/category/" + params,
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

//产品型号查询
export function getProductList(params) {
  return request({
    url: "/api/v1/product/detail/page",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品型号增加
export function addProduct(params) {
  return request({
    url: "/api/v1/product",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品型号修改
export function updataProduct(params) {
  return request({
    url: "/api/v1/product",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品型号删除
export function deleteProduct(params) {
  return request({
    url: "/api/v1/product/" + params,
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

// 查询默认部件
export function getProductDefault(id) {
  return request({
    url: "/api/v1/product/" + id + "/default-component",
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

//产品部件查询
export function getComponentList(params) {
  return request({
    url: "/api/v1/component/page",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}
//物料类型查询
export function getComponentTypeList() {
  return request({
    url: "/api/v1/component/type",
    method: "GET",
    headers: {
      "Content-Type": "x-www-form-urlencoded",
      "need-token": true
    }
  });
}

// 根据ids查询产品部件

export function getComponentByIds(params) {
  return request({
    url: "/api/v1/component/by/id",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品部件增加
export function addComponent(params) {
  params.code = params.code ? params.code : "";
  return request({
    url: "/api/v1/component",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品部件修改
export function updataComponent(params) {
  params.code = params.code ? params.code : "";
  return request({
    url: "/api/v1/component",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品部件删除
export function deleteComponent(params) {
  return request({
    url: "/api/v1/component/" + params,
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

// //部件分组查询
// export function getListGroup() {
//   return request({
//     url: "/api/v1/component/group",
//     method: "get",
//     headers: {
//       "Content-Type": "application/json",
//       "need-token": true
//     }
//   });
// }

//部件分组树查询
export function getTreeGroup() {
  return request({
    url: "/api/v1/component/group/tree",
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// //部件分组树带有子集部件查询
// export function getTreeGroupAll() {
//   return request({
//     url: "/api/v1/component/group/tree/all",
//     method: "get",
//     headers: {
//       "Content-Type": "application/json",
//       "need-token": true
//     }
//   });
// }
//查询分组树(lite)
export function groupTreeLite(params) {
  return request({
    url: "/api/v1/component/group/tree/lite",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 查询某个分组下的所有部件
export function componentByGroupId(params) {
  return request({
    url: "/api/v1/component/by/group-id",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//部件分组增加
export function addGroup(params) {
  return request({
    url: "/api/v1/component/group",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//部件分组移动
export function moveGroup(params) {
  return request({
    url: "/api/v1/component/move",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//部件分组修改
export function updataGroup(params) {
  return request({
    url: "/api/v1/component/group",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//部件分组删除
export function deleteGroup(params) {
  return request({
    url: "/api/v1/component/group/" + params,
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

//报价单查询列表
export function getQuotationList(params) {
  return request({
    url: "/api/v1/quotation/page",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//添加报价单
export function addQuotation(params) {
  return request({
    url: "/api/v1/quotation",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//删除报价单
export function deleteQuotation(params) {
  return request({
    url: "/api/v1/quotation/" + params,
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

//撤销报价单提交
export function withdrawQuotation(params) {
  return request({
    url: "/api/v1/quotation/withdraw",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//报价单重新提交提交
export function reeditQuotation(params) {
  return request({
    url: "/api/v1/quotation/reedit",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//查询报检单详情
export function getQuotationData(params) {
  return request({
    url: "/api/v1/quotation/" + params.id,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//暂存报价单
export function updataQuotation(params) {
  return request({
    url: "/api/v1/quotation/store",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//暂存并导出报价单
export function updataQuotationExport(params) {
  const url = `${apiConfig.baseURL}api/v1/quotation/store-and-export`;
  axios({
    url: url,
    method: "post",
    data: params,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      token: localStorage.getItem("token")
    }
  }).then(res => {
    const dispositionStr = res.headers["content-disposition"];

    if (dispositionStr == null || dispositionStr === "") {
      Message.warning("导出出错");
    } else {
      let dispositionArr = dispositionStr.split(";");
      let fileName = decodeURIComponent(dispositionArr[1]);
      fileName = fileName
        .split("=")[1]
        .trim()
        .replace(/^"(.*)"$/, "$1");
      console.log(fileName);
      try {
        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel; charset=utf-8"
        });
        const a = document.createElement("a");
        a.style.display = "none";
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
        Message.success("导出成功");
      } catch (e) {
        Message.error("导出失败");
      }
    }
  });
}
//提交报价单
export function submitQuotation(params) {
  return request({
    url: "/api/v1/quotation/submit",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//导出报价单
export function exportExcel(params) {
  let url = "api/v1/quotation/" + params.id + "/export/excel";
  // return request.get(url,{},{responseType:'blob','Content-Type': 'application/x-www-form-urlencoded',});
  return request({
    url: "/api/v1/quotation/" + params.id + "/export/excel",
    method: "get",
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      // "Content-Type":
      // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.ms-excel;charset=utf-8",
      // "responseType":'blob',
      responseType: "blob",
      "need-token": true
    }
  });
}

/**
 * 导出报价单
 *
 * @param {id:string} params
 * @author Howie Young
 */
export function exportExcel0(params) {
  const url = `${apiConfig.baseURL}api/v1/file/excel/quotation/${params.id}`;
  // do request
  const form = document.createElement("form");
  form.method = "get";
  form.action = url;
  form.target = "_blank";
  const ipt = document.createElement("input");
  ipt.type = "hidden";
  ipt.name = "token";
  ipt.value = localStorage.getItem("token");
  form.appendChild(ipt);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

// 审批报价单
export function quotationApproval(params) {
  return request({
    url: "/api/v1/quotation/approval",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 打回报价单
export function approvalReturn(quotationId) {
  return request({
    url: "/api/v1/quotation/approval/return-back/" + quotationId,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

// 查询所有质保年限

export function getWarrantyList(params) {
  return request({
    url: "/api/v1/product/warranty",
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

// 查询所有交期

export function getDeliveryList(params) {
  return request({
    url: "/api/v1/delivery",
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

//个人资产查询
export function getListPersonalAssets(params) {
  return request({
    url: "/api/v1/personal-assets/page",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//产品线增加
export function addPersonalAssets(params) {
  return request({
    url: "/api/v1/personal-assets/add",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//个人资产修改
export function updataPersonalAssets(params) {
  return request({
    url: "/api/v1/personal-assets/update",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//个人资产删除
export function deletePersonalAssets(params) {
  return request({
    url: "/api/v1/personal-assets/delete",
    data: params,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 获取系统设置
export function getConfig(params) {
  return request({
    url: "/api/v1/config",
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "need-token": true
    }
  });
}

//设置系统配置
export function setConfig(params) {
  return request({
    url: "/api/v1/config",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//上传文件
export function updataFiels(params) {
  return request({
    url: "/api/v1/assets/upload",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

export function parsePriceExcel(params) {
  return request({
    url: "/api/v1/component/parse-excel/price",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

export function updatePriceExcel(params) {
  return request({
    url: "/api/v1/component/batch/price",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//上传excel解析物料库管
export function updataExcel(params) {
  return request({
    url: "/api/v1/component/parse-excel/inventory",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//批量上传物料
export function batchComponent(params) {
  return request({
    url: "/api/v1/component/batch",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

export function updateStockBatch(params) {
  return request({
    url: "/api/v1/component/batch/inventory",
    method: "PUT",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

export function addStockBatch(params) {
  return request({
    url: "/api/v1/component/batch/inventory",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

// 导出物料
export function exportExcelComponent(params) {
  const url = `${apiConfig.baseURL}api/v1/component/excel`;
  axios({
    url: url,
    method: "post",
    data: params,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      token: localStorage.getItem("token")
    }
  }).then(res => {
    const dispositionStr = res.headers["content-disposition"];

    if (dispositionStr == null || dispositionStr === "") {
      Message.warning("导出出错");
    } else {
      let dispositionArr = dispositionStr.split(";");
      let fileName = decodeURIComponent(dispositionArr[1]);
      fileName = fileName
        .split("=")[1]
        .trim()
        .replace(/^"(.*)"$/, "$1");
      console.log(fileName);
      try {
        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel; charset=utf-8"
        });
        const a = document.createElement("a");
        a.style.display = "none";
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
        Message.success("导出成功");
      } catch (e) {
        Message.error("导出失败");
      }
    }
  });
}

//日志分页查询
export function systemLogList(params) {
  return request({
    url: "/api/v1/sys-log/page",
    method: "POST",
    data: params,
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}

//日志清理
export function systemLogClear() {
  return request({
    url: "/api/v1/sys-log/clear",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "need-token": true
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/product.js